(() => {
  function enhancePrivateCards() {
    const copyNode = document.getElementById('td-private-card-copy');
    if (!copyNode) return;
    const copy = JSON.parse(copyNode.textContent);
    document.querySelectorAll('.td-archive .v46-collection-card:not(.td-catalog-card)').forEach(card => {
      const details = copy[card.dataset.productHandle];
      const meta = card.querySelector('.product-meta');
      const media = card.querySelector('.product-media');
      const title = meta?.querySelector('h2');
      const price = meta?.querySelector('strong');
      const highlights = meta?.querySelector('p');
      const button = card.querySelector('.quick-buy-trigger');
      if (!details || !meta || !media || !title || !price || !highlights || !button) return;
      title.querySelector('a').textContent = details[0];
      highlights.textContent = details[1];
      title.classList.add('td-card-title');
      price.classList.add('td-card-price');
      highlights.classList.add('td-card-highlights');
      meta.classList.add('td-card-heading');
      media.append(button);
      card.classList.add('td-catalog-card');
    });
  }
  enhancePrivateCards();
  document.addEventListener('shopify:section:load', enhancePrivateCards);
})();
